import {Component, OnInit} from '@angular/core';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'busqueda-empleado',
  templateUrl: '../templates/busqueda.empleado.template.html'
})
export class BusquedaEmpleadoComponent implements OnInit {

  public idEmple: string = '';
  public documento: string = '';
  public nombre: string = '';

  public emples: any[] = [];

  constructor(private es: EmpleadoServices, private spinner:NgxSpinnerService) {
  }

  ngOnInit(): void {

  }

  buscarEmpleado() {
    this.spinner.show();
    this.es.devolverBusquedaEmpleado(this.idEmple,this.nombre,this.documento).subscribe(d=>{
      this.spinner.hide();
      console.log(d);
      this.emples = d.data.devolverTiendaDeEmpleado;

    })

  }

}
